import React, { Component } from 'react';
// import PropTypes from 'prop-types';
// import { connect } from 'react-redux';
import { Row, Col } from 'antd';
// import { withRouter, } from 'react-router-dom';
import imgBanner from '../../common/images/product/product-banner.png';
import imgProduct1 from '../../common/images/product/product1.png';
import imgProduct2 from '../../common/images/product/product2.png';
import imgProduct3 from '../../common/images/product/product3.png';
import imgProduct4 from '../../common/images/product/product4.png';
import imgRole1 from '../../common/images/product/role1.png';
import imgRole2 from '../../common/images/product/role2.png';
import imgRole3 from '../../common/images/product/role3.png';
import imgRole4 from '../../common/images/product/role4.png';
import imgCore1 from '../../common/images/product/core1.png';
import imgCore2 from '../../common/images/product/core2.png';
import imgCore3 from '../../common/images/product/core3.png';
import Title from '../../component/title/index';
import MyProduct from './index/product';
import Role from './index/role';
import './style.less';

// @withRouter
class Product extends Component {
  render() {
    const layout6 = { xs: 12, sm: 12, md: 6, lg: 6, xl: 6 };
    return (
      <div className='product'>
        <div className='banner'>
          <img src={imgBanner} alt='菜小秘' />
        </div>
        <div className='content2'>
          <Title>四大功能介绍</Title>
          <div className='container'>
            <MyProduct
              imgAlign='right'
              img={imgProduct2}
              title='收银下单'
              subTitle={
                <>
                  <div>▪️智能语音开单：搭载行业领先技术，话说完单子就开好了；</div>
                  <div>▪️复制粘贴开单：复制微信消息即可3秒开单，告别手写乱；</div>
                  <div>▪️多场景覆盖：适配即时开单与远程线上订货，降低沟通成本。</div>
                </>
              }
              content=''
            />
            <MyProduct
              imgAlign='left'
              img={imgProduct1}
              title='批次&库存管理'
              subTitle={
                <>
                  <div>▪️批次结算：批次状态、售卖详情及费用自动统计，结算高效，收益随时看；</div>
                  <div>▪️数据同步：货主通过货主通小程序实时查看销售进度与结算数据，避免对账扯皮；</div>
                  <div>▪️精准库存：来货、调货、盘点、报损一键操作，库存实时看，减少丢货与损耗。</div>
                </>
              }
              content=''
            />
            <MyProduct
              imgAlign='right'
              img={imgProduct3}
              title='全流程赊欠管理 '
              subTitle={
                <>
                  <div>▪️精准防控：自定义赊欠限额与账期，超额/逾期自动预警；</div>
                  <div>▪️透明对账：账单分享+买家通小程序，订单/欠款实时同步，支持赊欠确认避免纠纷；</div>
                  <div>▪️高效回款：线上线下多渠道还款，专业催款服务，非诉调解不回款不收费。</div>
                </>
              }
              content=''
            />
            <MyProduct
              imgAlign='left'
              img={imgProduct4}
              title='数据经营'
              subTitle={
                <>
                  <div>▪️多维度报表：经营总表、利润统计、进销存、收支赊欠等20多项报表自动生成，随时查看；</div>
                  <div>▪️分角色洞察：可按买家/货主/货品/销售经理等角色拆分数据，支持一键导出，月末对账快10倍。</div>
                </>
              }
              content=''
            />
          </div>
        </div>
        <div className='content3'>
          <Title>多终端角色协同</Title>
          <div className='title-sub-title'>手机/平板/电脑通用，老板/销售/收银/财务数据实时同步，档口经营效率提升70%</div>
          <div className='container'>
            <Row gutter={20} type='flex' justify='space-between' align='middle'>
              <Col {...layout6}>
                <Role img={imgRole1} title='销售经理' />
              </Col>
              <Col {...layout6}>
                <Role img={imgRole2} title='收银' />
              </Col>
              <Col {...layout6}>
                <Role img={imgRole3} title='财务' />
              </Col>
              <Col {...layout6}>
                <Role img={imgRole4} title='档主' />
              </Col>
            </Row>
          </div>
        </div>
        <div className='content4'>
          <Title>三大核心优势</Title>
          <div className='container'>
            <div className='core core1'>
              <div className='img'>
                <img src={imgCore1} alt='' />
              </div>
              <div className='text'>
                <div className='title'>技术引领</div>
                <div className='sub-content'>
                  <span className='sub-title'>【操作简单】</span>
                  <span>即学即会，秒速下单提高效率</span>
                  <br />
                  <span className='sub-title'>【场景适配】</span>
                  <span>功能组合，适配多种场景解决方案</span>
                  <br />
                  <span className='sub-title'>【高效管理】</span>
                  <span>账单明晰，赊欠风控放心无忧</span>
                  <br />
                  <span className='sub-title'>【移动办公】</span>
                  <span>方便快捷，多端协作随即切换</span>
                  <br />
                  <span className='sub-title'>【安全保障】</span>
                  <span>本地部署，随时保障你的数据安全</span>
                  <br />
                </div>
              </div>
            </div>
            <div className='core core2'>
              <div className='img'>
                <img src={imgCore2} alt='' />
              </div>
              <div className='text'>
                <div className='title'>客户为先</div>
                <div className='sub-content'>
                  <span className='sub-title'>【研发】</span>
                  <span>200+研发团队，技术支持，快速迭代</span>
                  <br />
                  <span className='sub-title'>【售后】</span>
                  <span>300+售后客服，24h跟踪，高效反馈</span>
                  <br />
                  <span className='sub-title'>【服务】</span>
                  <span>全国覆盖，遍布31个省</span>
                  <br />
                </div>
              </div>
            </div>
            <div className='core core3'>
              <div className='img'>
                <img src={imgCore3} alt='' />
              </div>
              <div className='text'>
                <div className='title'>厚积薄发</div>
                <div className='sub-content'>
                  <span className='sub-title'>【沉淀】</span>
                  <span>30年农批行业积累</span>
                  <br />
                  <span className='sub-title'>【覆盖】</span>
                  <span>合作商行70000+</span>
                  <br />
                  {/**1000+商行覆盖合作 */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Product;
